var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('img', {
    ref: "img",
    style: _vm.style,
    attrs: {
      "src": _vm.INITIAL_SRC,
      "draggable": "false"
    },
    on: {
      "dragstart": _vm.dragstart
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }